import service from "../../../../../api/services";
import {
  ErrorDataTable,
  HandleBulkInventoryApiReturn,
  PreparedDataReturn,
  TExcelData,
  TInventorySubmitApi,
  TVerifyBulkInventoryPayload,
} from "../interface";

export const useCallApi = () => {

  //function to remove the store code from barcode
  const removeStoreCode=(barcodes:string[], store_code:string):string[]=>{
    if(!barcodes || !store_code) return []
return barcodes?.map((barcode:string) => barcode?.startsWith(store_code) ? barcode?.slice(store_code?.length) : barcode );
  }

  //api for valid the data in inventory
  const verifyBulkInventory = async (data: PreparedDataReturn) => {
    const payload: TVerifyBulkInventoryPayload = {
      store_code: data?.store_code,
      products: data?.product_details?.map((item) => item?.product_id),
      barcodes: data?.product_details?.flatMap((item) => item?.barcodes),
    };
    try {
      const response = await service?.inventory?.bulkInventoryValid(payload);

      if (![200, 201].includes(response?.status)) {
        return { store_code: data.store_code, status: 400 };
      }

      const invalidProducts = response?.data?.data?.invalid_products;
      const cleanedBarcodes = removeStoreCode(response?.data?.data?.duplicate_barcodes , data?.store_code);
      
      if (invalidProducts?.length > 0) {
        const productIds = invalidProducts;
        return {
          store_code: data?.store_code,
          product_id: productIds,
          error_field: "Product ID",
          status: 400,
        };
      }

      if (cleanedBarcodes && cleanedBarcodes?.length > 0) {
        return {
          store_code: data?.store_code,
          product_id: "",
          barcodes: cleanedBarcodes,
          error_field: "Barcode",
          status: 400,
        };
      }

      return response?.data?.data;
    } catch (error) {
      console.error("error>>>>", error);
      return {
        status: 400,
        store_code: `${data?.store_code} (Wrong Store Code)`,
        error_field: "Storecode",
      };
    }
  };

  //for upload the bulk inventory
  const handleBulkInventoryApi = async (
    data: PreparedDataReturn
  ): Promise<TInventorySubmitApi> => {
    try {
      const response = await service?.inventory?.bulkInventory(data);
      return { message: "", status: 200 };
    } catch (error: any) {
      console.error(">>>", error);
      return { message: error?.response?.data?.message || "", status: 400 };
    }
  };

  //find the duplicate the entry
  const getDuplicateBarcodesFormatted = (
    data2: HandleBulkInventoryApiReturn[]
  ): ErrorDataTable[] => {
    if (!data2) return [];

    const counts: Record<string, number> = {};

    // Count all barcodes across items
    for (const item of data2) {
      const code = item.barcode;
      if (code) {
        counts[code] = (counts[code] ?? 0) + 1;
      }
    }

    const result: ErrorDataTable[] = [];

    // Build formatted output only for duplicates
    for (const item of data2) {
      const code = item.barcode;
      if (code && counts[code] > 1) {
        result.push({
          Storecode: item.store?.store_location || "",
          "Product ID": item?.product_id_display || "",
          Barcode: `${code} (Duplicate barcode)`,
          Unitcost: item.unit_const_amount ?? 0,
          Remark: item.remarks || "",
          error_field: "Barcode",
        });
      }
    }

    return result;
  };

  //end

  //find the empty entry in the data
  const getEmptyFieldsError = (data2: TExcelData[]): ErrorDataTable[] => {
    if (!data2) return [];
    const unitCostMap: Record<string, number> = {};

    const result: ErrorDataTable[] = [];
    for (const item of data2) {
      if (!item?.Remark) {
        result.push({ ...item, error_field: "Remark", isEmptyData: true });
      } else if (!item?.Unitcost) {
        result.push({ ...item, error_field: "Unitcost", isEmptyData: true });
      }
      // Check unit cost consistency
      const productId = item["Product ID"];
      if (productId) {
        if (!(productId in unitCostMap)) {
          unitCostMap[productId] = item.Unitcost;
        } else if (unitCostMap[productId] !== item.Unitcost) {
          result.push({
            ...item,
            error_field: "Unitcost",
            inconsistentUnitCost: true,
          });
        }
      }
    }

    return result;
  };

  return {
    handleBulkInventoryApi,
    verifyBulkInventory,
    getDuplicateBarcodesFormatted,
    getEmptyFieldsError,
  };
};
